import React from 'react';
import PropTypes from 'prop-types';
import { rawString } from '../Language';
import RefundOptions from '../RefundOptions';
import { OptionsList } from '../../components/OptionsList';
import { ResolutionForm } from './ResolutionForm';

export const ResolutionPicker = ({
  showRefundOptions,
  refundApiEnabled,
  refundOptionSettings,
  onRefundOptionChange,
  resolutionsEnabled,
  resolutionsConfig,
}) => {
  const handleResolutionChange = (e) => {
    onRefundOptionChange(e, e.value);
  };

  if (resolutionsEnabled && resolutionsConfig) {
    return (
      <ResolutionForm onChange={handleResolutionChange} resolutionsConfig={resolutionsConfig} />
    );
  }
  return (
    showRefundOptions && (
      <div>
        {refundApiEnabled && (
          <refund-options data-testid="refund-options">
            <RefundOptions />
          </refund-options>
        )}
        {refundOptionSettings?.enabled && (
          <div>
            <options-list data-testid="options-list">
              <OptionsList
                listTitle={rawString({ langKey: 'returns.step_3.refund_label' })}
                listOptions={refundOptionSettings?.options}
                listType={refundOptionSettings?.type}
                listOnChange={onRefundOptionChange}
              />
            </options-list>
          </div>
        )}
      </div>
    )
  );
};

ResolutionPicker.propTypes = {
  showRefundOptions: PropTypes.bool.isRequired,
  refundApiEnabled: PropTypes.bool.isRequired,
  refundOptionSettings: PropTypes.object,
  onRefundOptionChange: PropTypes.func.isRequired,
  isClaim: PropTypes.bool.isRequired,
};
